export default {
  data () {
    return {
      dictionary: {
        nfzOffices: {
          values: [
            {val: 'Dolnośląski Oddział Wojewódzki NFZ', text: 'Dolnośląski Oddział Wojewódzki NFZ'},
            {val: 'Kujawsko-Pomorski Oddział Wojewódzki NFZ', text: 'Kujawsko-Pomorski Oddział Wojewódzki NFZ'},
            {val: 'Lubelski Oddział Wojewódzki NFZ', text: 'Lubelski Oddział Wojewódzki NFZ'},
            {val: 'Lubuski Oddział Wojewódzki NFZ', text: 'Lubuski Oddział Wojewódzki NFZ'},
            {val: 'Łódzki Oddział Wojewódzki NFZ', text: 'Łódzki Oddział Wojewódzki NFZ'},
            {val: 'Małopolski Oddział Wojewódzki NFZ', text: 'Małopolski Oddział Wojewódzki NFZ'},
            {val: 'Mazowiecki Oddział Wojewódzki NFZ', text: 'Mazowiecki Oddział Wojewódzki NFZ'},
            {val: 'Opolski Oddział Wojewódzki NFZ', text: 'Opolski Oddział Wojewódzki NFZ'},
            {val: 'Podkarpacki Oddział Wojewódzki NFZ', text: 'Podkarpacki Oddział Wojewódzki NFZ'},
            {val: 'Podlaski Oddział Wojewódzki NFZ', text: 'Podlaski Oddział Wojewódzki NFZ'},
            {val: 'Pomorski Oddział Wojewódzki NFZ', text: 'Pomorski Oddział Wojewódzki NFZ'},
            {val: 'Śląski Oddział Wojewódzki NFZ', text: 'Śląski Oddział Wojewódzki NFZ'},
            {val: 'Świętokrzyski Oddział Wojewódzki NFZ', text: 'Świętokrzyski Oddział Wojewódzki NFZ'},
            {val: 'Warmińsko-Mazurski Oddział Wojewódzki NFZ', text: 'Warmińsko-Mazurski Oddział Wojewódzki NFZ'},
            {val: 'Wielkopolski Oddział Wojewódzki NFZ', text: 'Wielkopolski Oddział Wojewódzki NFZ'},
            {val: 'Zachodniopomorski Oddział Wojewódzki NFZ', text: 'Zachodniopomorski Oddział Wojewódzki NFZ'}
          ]
        },
        boardPositions: [
          {val: 'Prezes Zarządu', text: 'Prezes Zarządu'},
          {val: 'Wiceprezes Zarządu', text: 'Wiceprezes Zarządu'},
          {val: 'Członek Zarządu', text: 'Członek Zarządu'}
        ],
        krkOptions: [
          {val: 1, text: 'Załączę eKRK'},
          {val: 2, text: 'Dostarczę papierowy oryginał'},
          // {val: 3, text: 'Zezwalam na pobranie eKRK'},
        ],
        disabilityOptions: [
          {val: 'Brak', text: 'Brak'},
          {val: 'Lekki', text: 'Lekki'},
          {val: 'Umiarkowany', text: 'Umiarkowany'},
          {val: 'Znaczny', text: 'Znaczny'},
          {val: 'Odmawiam odpowiedzi', text: 'Odmawiam odpowiedzi'}
        ],
        companies: {
          1: 'Detal',
          3: 'Biznes',
          4: 'Ubezpieczenia',
          5: 'Inwestycje',
          6: 'Fotowoltaika'
        },
        company_names: {
          1: 'Grupa ANG S.A.',
          3: 'ANG Biznes S.A.',
          4: 'Grupa ANG S.A.',
          5: 'Grupa ANG S.A.',
          6: 'ANG Biznes S.A.'
        },
        company_groups: {
          1: 1,
          2: 1,
          3: 3,
          4: 4,
          5: 4,
          6: 5,
          7: 6,
          8: 1
        },
        groups: {
          1: 'Kredyty gotówkowe',
          2: 'Kredyty hipoteczne',
          8: 'Kredyty i pożyczki dla firm',
          3: 'Produkty leasingowe i faktoringowe',
          4: 'Ubezpieczenia majątkowe',
          5: 'Ubezpieczenia życiowe',
          6: 'Inwestycje',
          7: 'Fotowoltaika'
        },
        detalGroups: {
          1: 'Kredyty hipoteczne',
          3: 'Kredyty gotówkowe',
        },
        pensionOptions: [
          {val: 'Nie pobieram', text: 'Nie pobieram'},
          {val: 'Pobieram emeryturę', text: 'Pobieram emeryturę'},
          {val: 'Pobieram rentę', text: 'Pobieram rentę'},
          {val: 'Odmawiam odpowiedzi', text: 'Odmawiam odpowiedzi'}
        ],
        representationPositions: [
          {val: 'Prezes Zarządu', text: 'Prezes Zarządu'},
          {val: 'Wiceprezes Zarządu', text: 'Wiceprezes Zarządu'},
          {val: 'Członek Zarządu', text: 'Członek Zarządu'},
          {val: 'Prokurent', text: 'Prokurent'},
          {val: 'Pełnomocnik', text: 'Pełnomocnik'},
          {val: 'Wspólnik', text: 'Wspólnik'}
        ],
        advisorPositions: [
          {val: 4, text: 'Ekspert'},
          {val: 1, text: 'Manager'}
        ],
        provinces: {
          values: [
            {val: 'dolnośląskie', text: 'dolnośląskie'},
            {val: 'kujawsko-pomorskie', text: 'kujawsko-pomorskie'},
            {val: 'lubelskie', text: 'lubelskie'},
            {val: 'lubuskie', text: 'lubuskie'},
            {val: 'łódzkie', text: 'łódzkie'},
            {val: 'małopolskie', text: 'małopolskie'},
            {val: 'mazowieckie', text: 'mazowieckie'},
            {val: 'opolskie', text: 'opolskie'},
            {val: 'podkarpackie', text: 'podkarpackie'},
            {val: 'podlaskie', text: 'podlaskie'},
            {val: 'pomorskie', text: 'pomorskie'},
            {val: 'śląskie', text: 'śląskie'},
            {val: 'świętokrzyskie', text: 'świętokrzyskie'},
            {val: 'warmińsko-mazurskie', text: 'warmińsko-mazurskie'},
            {val: 'wielkopolskie', text: 'wielkopolskie'},
            {val: 'zachodniopomorskie', text: 'zachodniopomorskie'}
          ]
        },
        housingOptions: {
          values: [
            {val: 'Własne mieszkanie', text: 'Własne mieszkanie'},
            {val: 'Mieszkanie wynajęte', text: 'Mieszkanie wynajęte'},
            {val: 'Mieszkanie spółdzielcze/lokatorskie', text: 'Mieszkanie spółdzielcze/lokatorskie'},
            {val: 'Mieszkanie kwaterunkowe', text: 'Mieszkanie kwaterunkowe'},
            {val: 'Przy rodzinie', text: 'Przy rodzinie'},
            {val: 'Dom własny', text: 'Dom własny'},
            {val: 'Dom wynajęty', text: 'Dom wynajęty'},
            {val: 'TBS', text: 'TBS'},
            {val: 'Inne', text: 'Inne'}
          ]
        },
        martialOptions: {
          values:
              [
                {val: 'Mężatka/Żonaty', text: 'Mężatka/Żonaty'},
                {val: 'Panna/Kawaler', text: 'Panna/Kawaler'},
                {val: 'Wdowa/Wdowiec', text: 'Wdowa/Wdowiec'},
                {val: 'Rozwiedziona/-y', text: 'Rozwiedziona/-y'},
                {val: 'Konkubinat', text: 'Konkubinat'},
                {val: 'Separacja', text: 'Separacja'}
              ]
        },
        typeHousehold: {
          values:
              [
                {val: 'nie dotyczy (tylko jeden Wnioskodawca)', text: 'Nie dotyczy (tylko jeden Wnioskodawca)'},
                {val: 'związek małżeński', text: 'Związek małżeński'},
                {val: 'związek nieformalny', text: 'Związek nieformalny'},
              ]
        },
        educationOptions: {
          values:
              [
                {val: 'podstawowe', text: 'Podstawowe'},
                {val: 'podstawowe niepełne', text: 'Podstawowe niepełne'},
                {val: 'gimnazjalne', text: 'Gimnazjalne'},
                {val: 'średnie', text: 'Średnie'},
                {val: 'zawodowe / zasadnicze', text: 'Zawodowe / zasadnicze'},
                {val: 'technikum', text: 'Technikum'},
                {val: 'policealne', text: 'Policealne'},
                {val: 'wyższe (inżynier)', text: 'Wyższe (inżynier)'},
                {val: 'wyższe (licencjat)', text: 'Wyższe (licencjat)'},
                {val: 'wyższe magisterskie', text: 'Wyższe magisterskie'},
                {val: 'wyższe doktoranckie', text: 'Wyższe doktoranckie'},
                {val: 'wyższe + podyplomowe', text: 'Wyższe + podyplomowe'},
                {val: 'MBA', text: 'MBA'}
              ]
        },
        recruitEducationOptions: {
          values:
              [
                {val: 'średnie', text: 'średnie'},
                {val: 'wyższe', text: 'Wyższe'}
              ]
        },
        peopleOptions: {
          values:
              [
                {val: 1, text: 1},
                {val: 2, text: 2},
                {val: 3, text: 3},
                {val: 4, text: 4},
                {val: 5, text: 5},
                {val: 6, text: 6},
                {val: 7, text: 7},
                {val: 8, text: 8},
                {val: 9, text: 9},
                {val: 10, text: 10}
              ]
        },
        childernOptions: {
          values:
              [
                {val: 0, text: 0},
                {val: 1, text: 1},
                {val: 2, text: 2},
                {val: 3, text: 3},
                {val: 4, text: 4},
                {val: 5, text: 5},
                {val: 6, text: 6},
                {val: 7, text: 7},
                {val: 8, text: 8},
                {val: 9, text: 9},
                {val: 10, text: 10}
              ]
        },
        provinceOptions: {
          values: [
            {val: 'dolnośląskie', text: 'dolnośląskie'},
            {val: 'kujawsko-pomorskie', text: 'kujawsko-pomorskie'},
            {val: 'lubelskie', text: 'lubelskie'},
            {val: 'lubuskie', text: 'lubuskie'},
            {val: 'łódzkie', text: 'łódzkie'},
            {val: 'małopolskie', text: 'małopolskie'},
            {val: 'mazowieckie', text: 'mazowieckie'},
            {val: 'opolskie', text: 'opolskie'},
            {val: 'podkarpackie', text: 'podkarpackie'},
            {val: 'podlaskie', text: 'podlaskie'},
            {val: 'pomorskie', text: 'pomorskie'},
            {val: 'śląskie', text: 'śląskie'},
            {val: 'świętokrzyskie', text: 'świętokrzyskie'},
            {val: 'warmińsko-mazurskie', text: 'warmińsko-mazurskie'},
            {val: 'wielkopolskie', text: 'wielkopolskie'},
            {val: 'zachodniopomorskie', text: 'zachodniopomorskie'}
          ]
        },
        positionTypes: {
          values: [
            {val: 'górnik', text: 'Górnik'},
            {val: 'kadra zarządzająca (prezes, członek zarządu itd.)', text: 'Kadra zarządzająca (prezes, członek zarządu itd.)'},
            {val: 'kolejarz', text: 'Kolejarz'},
            {val: 'lekarz', text: 'Lekarz'},
            {val: 'marynarz', text: 'Marynarz'},
            {val: 'nauczyciel (wszystkie poziomy)', text: 'Nauczyciel (wszystkie poziomy)'},
            {val: 'osoba prowadząca działalność gospodarczą', text: 'Osoba prowadząca działalność gospodarczą'},
            {val: 'personel medyczny', text: 'Personel medyczny'},
            {val: 'pracownik biurowy', text: 'Pracownik biurowy'},
            {val: 'pracownik fizyczny', text: 'Pracownik fizyczny'},
            {val: 'pracownik umysłowy (np. specjalista)', text: 'Pracownik umysłowy (np. specjalista)'},
            {val: 'rolnik, ogrodnik, rybak', text: 'Rolnik, ogrodnik, rybak'},
            {val: 'służby mundurowe', text: 'Służby mundurowe'},
            {val: 'stanowisko kierownicze / dyrektorskie', text: 'Stanowisko kierownicze / dyrektorskie'},
            {val: 'uczeń / student', text: 'Uczeń / student'},
            {val: 'urzędnik państwowy', text: 'Urzędnik państwowy'},
            {val: 'właściciel firmy', text: 'Właściciel firmy'},
            {val: 'zawód prawniczy', text: 'Zawód prawniczy'},
            {val: 'zawód wolny', text: 'Zawód wolny'},
            {val: 'inne / brak danych', text: 'Inne / brak danych'},
          ]
        },
        workplaceTypes: {
          values: [
            {val: 'Administracja państwowa', text: 'Administracja państwowa'},
            {val: 'Firma państwowa', text: 'Firma państwowa'},
            {val: 'Jednostka samorządowa', text: 'Jednostka samorządowa'},
            {val: 'Placówka publiczna (np. szpitale, szkoły)', text: 'Placówka publiczna (np. szpitale, szkoły)'},
            {val: 'Przedsiębiorca indywidualny', text: 'Przedsiębiorca indywidualny'},
            {val: 'Sfera budżetowa', text: 'Sfera budżetowa'},
            {val: 'Spółdzielnia', text: 'Spółdzielnia'},
            {val: 'Spółdzielnia akcyjna', text: 'Spółdzielnia akcyjna'},
            {val: 'Spółka cywilna', text: 'Spółka cywilna'},
            {val: 'Spółka jawna', text: 'Spółka jawna'},
            {val: 'Spółka Skarbu Państwa', text: 'Spółka Skarbu Państwa'},
            {val: 'Spółka z o.o.', text: 'Spółka z o.o.'},
            {val: 'inna spółka', text: 'Inna spółka'},
            {val: 'Inny', text: 'Inny'},
          ]
        },
        loanPurpose: {
          values: [
            {val: 'adaptacja pomieszczenia niemieszkalnego na potrzeby mieszkaniowe', text: 'Adaptacja pomieszczenia niemieszkalnego na potrzeby mieszkaniowe'},
            {val: 'budowa / rozbudowa / dokończenie budowy', text: 'Budowa / rozbudowa / dokończenie budowy'},
            {val: 'budowa domu jednorodzinnego, domu letniskowego o przeznaczeniu całorocznym na działce rekreacyjnej', text: 'Budowa domu jednorodzinnego, domu letniskowego o przeznaczeniu całorocznym na działce rekreacyjnej'},
            {val: 'budowa indywidualna', text: 'Budowa indywidualna'},
            {val: 'budowa nieruchomości mieszkalnej (rynek pierwotny)', text: 'Budowa nieruchomości mieszkalnej (rynek pierwotny)'},
            {val: 'budowa nieruchomości mieszkalnej z częścią usługową', text: 'Budowa nieruchomości mieszkalnej z częścią usługową'},
            {val: 'budowa przez dewelopera / spółdzielnię', text: 'Budowa przez dewelopera / spółdzielnię'},
            {val: 'cel konsumpcyjny', text: 'Cel konsumpcyjny'},
            {val: 'konsolidacja', text: 'Konsolidacja'},
            {val: 'koszt projektu rozwiązań ekologicznych, koszt audytu energetycznego', text: 'Koszt projektu rozwiązań ekologicznych, koszt audytu energetycznego'},
            {val: 'koszty sądowe i opłaty notarialne, inne koszty i opłaty urzędowe', text: 'Koszty sądowe i opłaty notarialne, inne koszty i opłaty urzędowe'},
            {val: 'nabycie spółdzielczego własnościowego prawa do lokalu mieszkalnego', text: 'Nabycie spółdzielczego własnościowego prawa do lokalu mieszkalnego'},
            {val: 'nabycie własnościowego prawa do domu jednorodzinnego (wybudowanego) w spółdzielni mieszkaniowej', text: 'Nabycie własnościowego prawa do domu jednorodzinnego (wybudowanego) w spółdzielni mieszkaniowej'},
            {val: 'prace budowlane bez pozwolenia / bez zgłoszenia', text: 'Prace budowlane bez pozwolenia / bez zgłoszenia'},
            {val: 'prace budowlane z pozwoleniem na budowę lub zgłoszeniem z projektem budowlanym', text: 'Prace budowlane z pozwoleniem na budowę lub zgłoszeniem z projektem budowlanym'},
            {val: 'prace budowlane ze zgłoszeniem bez projektu budowlanego', text: 'Prace budowlane ze zgłoszeniem bez projektu budowlanego'},
            {val: 'prowizja należna podmiotom pośredniczącym w zawieraniu transakcji', text: 'Prowizja należna podmiotom pośredniczącym w zawieraniu transakcji'},
            {val: 'przekształcenie lokatorskiego spółdzielczego prawa w spółdzielcze własnościowe prawo lub w prawo odrębnej własności', text: 'Przekształcenie lokatorskiego spółdzielczego prawa w spółdzielcze własnościowe prawo lub w prawo odrębnej własności'},
            {val: 'przekształcenie lokatorskiego spółdzielczego prawa do nieruchomości mieszkalnej w prawo odrębnej własności', text: 'Przekształcenie lokatorskiego spółdzielczego prawa do nieruchomości mieszkalnej w prawo odrębnej własności'},
            {val: 'refinansowanie środków własnych', text: 'Refinansowanie środków własnych'},
            {val: 'refinansowanie udokumentowanych kosztów nabycia lub budowy', text: 'Refinansowanie udokumentowanych kosztów nabycia lub budowy'},
            {val: 'refinansowanie udokumentowanych kosztów wykupu lub innych prac budowlanych', text: 'Refinansowanie udokumentowanych kosztów wykupu lub innych prac budowlanych'},
            {val: 'remont nieruchomości użytkowej', text: 'Remont nieruchomości użytkowej'},
            {val: 'remont użytkowanej nieruchomości mieszkalnej', text: 'Remont użytkowanej nieruchomości mieszkalnej'},
            {val: 'spłata kredytu hipotecznego w innym banku', text: 'Spłata kredytu hipotecznego w innym banku'},
            {val: 'spłata kredytu zaciągniętego na inne cele niż mieszkaniowe', text: 'Spłata kredytu zaciągniętego na inne cele niż mieszkaniowe'},
            {val: 'wykończenie nieruchomości mieszkalnej (rynek pierwotny)', text: 'Wykończenie nieruchomości mieszkalnej (rynek pierwotny)'},
            {val: 'wykończenie nieruchomości użytkowej (rynek pierwotny)', text: 'Wykończenie nieruchomości użytkowej (rynek pierwotny)'},
            {val: 'wykończenie nieruchomości użytkowej (rynek pierwotny)', text: 'Wykończenie nieruchomości użytkowej (rynek pierwotny)'},
            {val: 'wykup nieruchomości mieszkalnej', text: 'Wykup nieruchomości mieszkalnej'},
            {val: 'zakup domu jednorodzinnego', text: 'Zakup domu jednorodzinnego'},
            {val: 'zakup działki niezabudowanej (lub z rozpoczętą budową)', text: 'Zakup działki niezabudowanej (lub z rozpoczętą budową)'},
            {val: 'zakup garażu / miejsca postojowego', text: 'Zakup garażu / miejsca postojowego'},
            {val: 'zakup gruntów rolnych', text: 'Zakup gruntów rolnych'},
            {val: 'zakup lokalu użytkowego (rynek pierwotny)', text: 'Zakup lokalu użytkowego (rynek pierwotny)'},
            {val: 'zakup lokalu użytkowego (rynek pierwotny)', text: 'Zakup lokalu użytkowego (rynek pierwotny)'},
            {val: 'zakup nieruchomości mieszkalnej (rynek pierwotny)', text: 'Zakup nieruchomości mieszkalnej (rynek pierwotny)'},
            {val: 'zakup nieruchomości mieszkalnej (rynek wtórny)', text: 'Zakup nieruchomości mieszkalnej (rynek wtórny)'},
            {val: 'zakup nieruchomości mieszkalnej z częścią usługową', text: 'Zakup nieruchomości mieszkalnej z częścią usługową'},
            {val: 'zakup nieruchomości w drodze licytacji z egzekucji komorniczej', text: 'Zakup nieruchomości w drodze licytacji z egzekucji komorniczej'},
            {val: 'zakup nieruchomości w drodze przetargu/licytacji od dewelopera lub spółdzielni mieszkaniowej', text: 'Zakup nieruchomości w drodze przetargu/licytacji od dewelopera lub spółdzielni mieszkaniowej'},
            {val: 'zakup udziału we współwłasności nieruchomości', text: 'Zakup udziału we współwłasności nieruchomości'},
          ]
        },
        propertyParameters : {
          values: [
            {val: 'bliźniak', text: 'Bliźniak'},
            {val: 'dom jednorodzinny', text: 'Dom jednorodzinny'},
            {val: 'dom letniskowy całoroczny', text: 'Dom letniskowy całoroczny'},
            {val: 'działka budowlana', text: 'Działka budowlana'},
            {val: 'działka rekreacyjna', text: 'Działka rekreacyjna'},
            {val: 'garaż / miejsce postojowe', text: 'Garaż / miejsce postojowe'},
            {val: 'kamienica', text: 'Kamienica'},
            {val: 'nieruchomość mieszkalna', text: 'Nieruchomość mieszkalna'},
            {val: 'nieruchomość rolno-siedliskowa', text: 'Nieruchomość rolno-siedliskowa'},
            {val: 'nieruchomość użytkowa (komercyjna)', text: 'Nieruchomość użytkowa (komercyjna)'},
            {val: 'segment', text: 'Segment'},
            {val: 'udział w drodze', text: 'Udział w drodze'},
          ]
        },
        ownership : {
          values: [
            {val: 'działka zabudowana z budynkiem mieszkalnym', text: 'Działka zabudowana z budynkiem mieszkalnym'},
            {val: 'niezabudowana działka gruntu', text: 'Niezabudowana działka gruntu'},
            {val: 'odrębna własność lokalu mieszkalnego / użytkowego', text: 'Odrębna własność lokalu mieszkalnego / użytkowego'},
            {val: 'spółdzielcze własnościowe prawo do lokalu', text: 'Spółdzielcze własnościowe prawo do lokalu'},
            {val: 'udział w prawie własności hali garażowej / parkingu', text: 'Udział w prawie własności hali garażowej / parkingu'},
            {val: 'użytkowanie wieczyste (działka niezabudowana)', text: 'Użytkowanie wieczyste (działka niezabudowana)'},
            {val: 'użytkowanie wieczyste działki gruntu i własność budynku', text: 'Użytkowanie wieczyste działki gruntu i własność budynku'},
            {val: 'własność działki gruntu i budynku mieszkalnego', text: 'Własność działki gruntu i budynku mieszkalnego'},
            {val: 'własność lokalu mieszkalnego', text: 'Własność lokalu mieszkalnego'},
            {val: 'własność lub użytkowanie wieczyste działki gruntu', text: 'Własność lub użytkowanie wieczyste działki gruntu'},
          ]
        },
        incomeCurrency : {
          values: [
            {val: 'PLN' , text: 'PLN' },
            {val: 'USD' , text: 'USD' },
            {val: 'EUR' , text: 'EUR' },
            {val: 'GBP' , text: 'GBP' },
            {val: 'CHF' , text: 'CHF' },
            {val: 'NOK' , text: 'NOK' },
          ]
        },
        taxCountry: {
          values: [
            {val: 'Polska', text: 'Polska'},
            {val: 'Afganistan', text: 'Afganistan'},
            {val: 'Albania', text: 'Albania'},
            {val: 'Algieria', text: 'Algieria'},
            {val: 'Andora', text: 'Andora'},
            {val: 'Angola', text: 'Angola'},
            {val: 'Antigua i Barbuda', text: 'Antigua i Barbuda'},
            {val: 'Arabia Saudyjska', text: 'Arabia Saudyjska'},
            {val: 'Argentyna', text: 'Argentyna'},
            {val: 'Armenia', text: 'Armenia'},
            {val: 'Australia', text: 'Australia'},
            {val: 'Austria', text: 'Austria'},
            {val: 'Azerbejdżan', text: 'Azerbejdżan'},
            {val: 'Bahamy', text: 'Bahamy'},
            {val: 'Bahrajn', text: 'Bahrajn'},
            {val: 'Bangladesz', text: 'Bangladesz'},
            {val: 'Barbados', text: 'Barbados'},
            {val: 'Belgia', text: 'Belgia'},
            {val: 'Belize', text: 'Belize'},
            {val: 'Benin', text: 'Benin'},
            {val: 'Bhutan', text: 'Bhutan'},
            {val: 'Białoruś', text: 'Białoruś'},
            {val: 'Birma', text: 'Birma'},
            {val: 'Boliwia', text: 'Boliwia'},
            {val: 'Bośnia i Hercegowina', text: 'Bośnia i Hercegowina'},
            {val: 'Botswana', text: 'Botswana'},
            {val: 'Brazylia', text: 'Brazylia'},
            {val: 'Brunei', text: 'Brunei'},
            {val: 'Bułgaria', text: 'Bułgaria'},
            {val: 'Burkina Faso', text: 'Burkina Faso'},
            {val: 'Burundi', text: 'Burundi'},
            {val: 'Chile', text: 'Chile'},
            {val: 'Chiny', text: 'Chiny'},
            {val: 'Chorwacja', text: 'Chorwacja'},
            {val: 'Cypr', text: 'Cypr'},
            {val: 'Czad', text: 'Czad'},
            {val: 'Czarnogóra', text: 'Czarnogóra'},
            {val: 'Czechy', text: 'Czechy'},
            {val: 'Dania', text: 'Dania'},
            {val: 'Demokratyczna Republika Konga', text: 'Demokratyczna Republika Konga'},
            {val: 'Dominika', text: 'Dominika'},
            {val: 'Dominikana', text: 'Dominikana'},
            {val: 'Dżibuti', text: 'Dżibuti'},
            {val: 'Egipt', text: 'Egipt'},
            {val: 'Ekwador', text: 'Ekwador'},
            {val: 'Erytrea', text: 'Erytrea'},
            {val: 'Estonia', text: 'Estonia'},
            {val: 'Eswatini', text: 'Eswatini'},
            {val: 'Etiopia', text: 'Etiopia'},
            {val: 'Fidżi', text: 'Fidżi'},
            {val: 'Filipiny', text: 'Filipiny'},
            {val: 'Finlandia', text: 'Finlandia'},
            {val: 'Francja', text: 'Francja'},
            {val: 'Gabon', text: 'Gabon'},
            {val: 'Gambia', text: 'Gambia'},
            {val: 'Ghana', text: 'Ghana'},
            {val: 'Grecja', text: 'Grecja'},
            {val: 'Grenada', text: 'Grenada'},
            {val: 'Gruzja', text: 'Gruzja'},
            {val: 'Gujana', text: 'Gujana'},
            {val: 'Gwatemala', text: 'Gwatemala'},
            {val: 'Gwinea', text: 'Gwinea'},
            {val: 'Gwinea Bissau', text: 'Gwinea Bissau'},
            {val: 'Gwinea Równikowa', text: 'Gwinea Równikowa'},
            {val: 'Haiti', text: 'Haiti'},
            {val: 'Hiszpania', text: 'Hiszpania'},
            {val: 'Holandia', text: 'Holandia'},
            {val: 'Honduras', text: 'Honduras'},
            {val: 'Indie', text: 'Indie'},
            {val: 'Indonezja', text: 'Indonezja'},
            {val: 'Irak', text: 'Irak'},
            {val: 'Iran', text: 'Iran'},
            {val: 'Irlandia', text: 'Irlandia'},
            {val: 'Islandia', text: 'Islandia'},
            {val: 'Izrael', text: 'Izrael'},
            {val: 'Jamajka', text: 'Jamajka'},
            {val: 'Japonia', text: 'Japonia'},
            {val: 'Jemen', text: 'Jemen'},
            {val: 'Jordania', text: 'Jordania'},
            {val: 'Kambodża', text: 'Kambodża'},
            {val: 'Kamerun', text: 'Kamerun'},
            {val: 'Kanada', text: 'Kanada'},
            {val: 'Katar', text: 'Katar'},
            {val: 'Kazachstan', text: 'Kazachstan'},
            {val: 'Kenia', text: 'Kenia'},
            {val: 'Kirgistan', text: 'Kirgistan'},
            {val: 'Kiribati', text: 'Kiribati'},
            {val: 'Kolumbia', text: 'Kolumbia'},
            {val: 'Komory', text: 'Komory'},
            {val: 'Korea Południowa', text: 'Korea Południowa'},
            {val: 'Korea Północna', text: 'Korea Północna'},
            {val: 'Kosowo', text: 'Kosowo'},
            {val: 'Kostaryka', text: 'Kostaryka'},
            {val: 'Kuba', text: 'Kuba'},
            {val: 'Kuwejt', text: 'Kuwejt'},
            {val: 'Laos', text: 'Laos'},
            {val: 'Lesotho', text: 'Lesotho'},
            {val: 'Liban', text: 'Liban'},
            {val: 'Liberia', text: 'Liberia'},
            {val: 'Libia', text: 'Libia'},
            {val: 'Liechtenstein', text: 'Liechtenstein'},
            {val: 'Litwa', text: 'Litwa'},
            {val: 'Luksemburg', text: 'Luksemburg'},
            {val: 'Łotwa', text: 'Łotwa'},
            {val: 'Macedonia Północna', text: 'Macedonia Północna'},
            {val: 'Madagaskar', text: 'Madagaskar'},
            {val: 'Malawi', text: 'Malawi'},
            {val: 'Malediwy', text: 'Malediwy'},
            {val: 'Malezja', text: 'Malezja'},
            {val: 'Mali', text: 'Mali'},
            {val: 'Malta', text: 'Malta'},
            {val: 'Maroko', text: 'Maroko'},
            {val: 'Mauretania', text: 'Mauretania'},
            {val: 'Mauritius', text: 'Mauritius'},
            {val: 'Meksyk', text: 'Meksyk'},
            {val: 'Mikronezja', text: 'Mikronezja'},
            {val: 'Mjanma', text: 'Mjanma'},
            {val: 'Mołdawia', text: 'Mołdawia'},
            {val: 'Monako', text: 'Monako'},
            {val: 'Mongolia', text: 'Mongolia'},
            {val: 'Mozambik', text: 'Mozambik'},
            {val: 'Namibia', text: 'Namibia'},
            {val: 'Nauru', text: 'Nauru'},
            {val: 'Nepal', text: 'Nepal'},
            {val: 'Niemcy', text: 'Niemcy'},
            {val: 'Niger', text: 'Niger'},
            {val: 'Nigeria', text: 'Nigeria'},
            {val: 'Nikaragua', text: 'Nikaragua'},
            {val: 'Norwegia', text: 'Norwegia'},
            {val: 'Nowa Zelandia', text: 'Nowa Zelandia'},
            {val: 'Oman', text: 'Oman'},
            {val: 'Pakistan', text: 'Pakistan'},
            {val: 'Palau', text: 'Palau'},
            {val: 'Panama', text: 'Panama'},
            {val: 'Papua-Nowa Gwinea', text: 'Papua-Nowa Gwinea'},
            {val: 'Paragwaj', text: 'Paragwaj'},
            {val: 'Peru', text: 'Peru'},
            {val: 'Portugalia', text: 'Portugalia'},
            {val: 'Republika Południowej Afryki', text: 'Republika Południowej Afryki'},
            {val: 'Republika Środkowoafrykańska', text: 'Republika Środkowoafrykańska'},
            {val: 'Republika Zielonego Przylądka', text: 'Republika Zielonego Przylądka'},
            {val: 'Rosja', text: 'Rosja'},
            {val: 'Rumunia', text: 'Rumunia'},
            {val: 'Rwanda', text: 'Rwanda'},
            {val: 'Saint Kitts i Nevis', text: 'Saint Kitts i Nevis'},
            {val: 'Saint Lucia', text: 'Saint Lucia'},
            {val: 'Saint Vincent i Grenadyny', text: 'Saint Vincent i Grenadyny'},
            {val: 'Salwador', text: 'Salwador'},
            {val: 'Samoa', text: 'Samoa'},
            {val: 'San Marino', text: 'San Marino'},
            {val: 'Senegal', text: 'Senegal'},
            {val: 'Serbia', text: 'Serbia'},
            {val: 'Seszele', text: 'Seszele'},
            {val: 'Sierra Leone', text: 'Sierra Leone'},
            {val: 'Singapur', text: 'Singapur'},
            {val: 'Słowacja', text: 'Słowacja'},
            {val: 'Słowenia', text: 'Słowenia'},
            {val: 'Somalia', text: 'Somalia'},
            {val: 'Sri Lanka', text: 'Sri Lanka'},
            {val: 'Stany Zjednoczone', text: 'Stany Zjednoczone'},
            {val: 'Sudan', text: 'Sudan'},
            {val: 'Sudan Południowy', text: 'Sudan Południowy'},
            {val: 'Surinam', text: 'Surinam'},
            {val: 'Syria', text: 'Syria'},
            {val: 'Szwajcaria', text: 'Szwajcaria'},
            {val: 'Szwecja', text: 'Szwecja'},
            {val: 'Tadżykistan', text: 'Tadżykistan'},
            {val: 'Tajlandia', text: 'Tajlandia'},
            {val: 'Tanzania', text: 'Tanzania'},
            {val: 'Timor Wschodni', text: 'Timor Wschodni'},
            {val: 'Togo', text: 'Togo'},
            {val: 'Tonga', text: 'Tonga'},
            {val: 'Trynidad i Tobago', text: 'Trynidad i Tobago'},
            {val: 'Tunezja', text: 'Tunezja'},
            {val: 'Turcja', text: 'Turcja'},
            {val: 'Turkmenistan', text: 'Turkmenistan'},
            {val: 'Tuvalu', text: 'Tuvalu'},
            {val: 'Uganda', text: 'Uganda'},
            {val: 'Ukraina', text: 'Ukraina'},
            {val: 'Urugwaj', text: 'Urugwaj'},
            {val: 'Uzbekistan', text: 'Uzbekistan'},
            {val: 'Vanuatu', text: 'Vanuatu'},
            {val: 'Watykan', text: 'Watykan'},
            {val: 'Wenezuela', text: 'Wenezuela'},
            {val: 'Węgry', text: 'Węgry'},
            {val: 'Wielka Brytania', text: 'Wielka Brytania'},
            {val: 'Wietnam', text: 'Wietnam'},
            {val: 'Włochy', text: 'Włochy'},
            {val: 'Wybrzeże Kości Słoniowej', text: 'Wybrzeże Kości Słoniowej'},
            {val: 'Wyspy Marshalla', text: 'Wyspy Marshalla'},
            {val: 'Wyspy Salomona', text: 'Wyspy Salomona'},
            {val: 'Wyspy Świętego Tomasza i Książęca', text: 'Wyspy Świętego Tomasza i Książęca'},
            {val: 'Zambia', text: 'Zambia'},
            {val: 'Zimbabwe', text: 'Zimbabwe'},
            {val: 'Zjedonoczone Emiraty Arabskie', text: 'Zjedonoczone Emiraty Arabskie'},
          ]
        },
      }
    }
  },
  created () {
  }
}
